module.exports = __webpack_public_path__ + "img/home-1-mobile.80f9757a.jpg";